module.exports = __webpack_public_path__ + "img/HealthSpot.59dd6088.png";